//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"Direction",1,"Direction",0],[0,"Joggle",1,"Features.EmbossJoggle",0],[0,"SidewallOption",1,0]],[[["angle"],"SetAngle",{},1,0],[["angle"],"SetNewAngle",{},1,0],[["tapers"],"SetTapers",{},1,0],[["n_tapers"],"GetTapers",{R_:{tapers:"Features.EmbossTaper[]"}},0,0],[[],"AddNewTaper",{R_:{new_taper:"Features.EmbossTaper"}},0,0],[["index"],"RemoveTaper",{},1,0],[["useSameAngleButton"],"SetUseSameAngleButton",{},1,0],[[],"GetUseSameAngleButton",{R_:{useSameAngleButton:''}},0,0]],[]];
SPLM.Features.EmbossSidewall = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.EmbossSidewall";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.EmbossSidewall.SidewallMethod = Object.freeze({
    "IsoclineTapered" : "IsoclineTapered", "CurveTapered" : "CurveTapered", "Ruled" : "Ruled", "Swept" : "Swept", "Normal" : "Normal", "TwoSection" : "TwoSection", "Offset" : "Offset"});

export default SPLM;